export const userGeneralInfoContent = {
  en: (
    <div className="max-w-5xl mx-auto px-6 space-y-8">
      {/* Notes */}
      <section className="pl-4 border-l-4 border-blue-500">
        <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
          <span className="text-blue-500">ℹ️</span> Important Notes for
          Application
        </h3>
        <ul className="list-disc ml-6 space-y-1 text-gray-700">
          <li>
            Application for subsidy only after project starts commercial
            operation.
          </li>
        </ul>
        <hr className="my-4 border-gray-300" />
      </section>

      {/* Timelines */}
      <section className="pl-4 border-l-4 border-yellow-500">
        <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
          ⏳ Timelines
        </h3>
        <ul className="list-disc ml-6 space-y-1 text-gray-700">
          <li>
            Project must be completed within <b>3 years</b> from approval.
          </li>
          <li>
            Capital subsidy (stamp duty) within <b>6 months</b> of Commercial
            Operation.
          </li>
          <li>
            Interest subsidy within <b>90 days</b> after 1 year of Commercial
            Operation.
          </li>
        </ul>
      </section>

      {/* Provisions */}
      <section className="pl-4 border-l-4 border-red-500">
        <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
          📌 Key Provisions of the Scheme
        </h3>
        <ul className="list-disc ml-6 space-y-1 text-gray-700">
          <li>For permanent residents/entrepreneurs of Uttarakhand.</li>
          <li>Investment range: ₹1 crore – ₹5 crore.</li>
          <li>Eligible: Proprietorship, Partnership, LLP, Pvt. Ltd.</li>
          <li>Land must be owned/leased (10 years+).</li>
          <li>Eligible activities: Hotels, Resorts, Adventure Parks.</li>
        </ul>
      </section>

      {/* Subsidy */}
      <section className="pl-4 border-l-4 border-green-500">
        <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
          💰 Financial Subsidy / Incentives
        </h3>
        <ul className="list-disc ml-6 space-y-1 text-gray-700">
          <li>
            <b>Stamp Duty:</b> 100% reimbursement (new units only)
          </li>
          <li>
            <b>Capital Subsidy:</b>
            <ul className="list-disc ml-6 space-y-1">
              <li>₹33 lakh minimum (on ₹1 crore)</li>
              <li>Category A: 15% up to ₹80 lakh</li>
              <li>Category B: 25% up to ₹1.2 crore</li>
              <li>Category C: 30% up to ₹1.5 crore</li>
            </ul>
          </li>
          <li>
            <b>Interest Subsidy (3 years):</b>
            <ul className="list-disc ml-6 space-y-1">
              <li>Category A: 3% (max ₹4 lakh/year)</li>
              <li>Category B: 3% (max ₹5 lakh/year)</li>
              <li>Category C: 3% (max ₹6 lakh/year)</li>
            </ul>
          </li>
        </ul>
      </section>

      {/* Regions */}
      <section className="pl-4 border-l-4 border-purple-500">
        <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
          📍 Eligible Regions
        </h3>
        <p className="text-gray-700 ml-6">
          <b>Category A:</b> Haridwar, Nainital, Dehradun (excluding B areas),
          Almora (Ranikhet, Almora tehsil).
          <br />
          <b>Category B:</b> Dehradun (Kalsi, Chakrata, Tyuni), Almora (rest),
          Bageshwar (Garur), Pithoragarh (Didihat, Munakot), Tehri (New Tehri).
          <br />
          <b>Category C:</b> Uttarkashi, Champawat, Pauri, Rudraprayag, Chamoli,
          Bageshwar (rest), Pithoragarh (rest), Tehri (rest).
        </p>
      </section>
    </div>
  ),

  hi: (
    <div className="max-w-5xl mx-auto px-6 space-y-8">
      {/* Notes */}
      <section className="pl-4 border-l-4 border-blue-500">
        <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
          <span className="text-blue-500">ℹ️</span> आवेदन हेतु महत्वपूर्ण सूचना
        </h3>
        <ul className="list-disc ml-6 space-y-1 text-gray-700">
          <li>
            सब्सिडी हेतु आवेदन केवल परियोजना के वाणिज्यिक संचालन प्रारंभ होने के
            बाद ही किया जा सकता है।
          </li>
        </ul>
        <hr className="my-4 border-gray-300" />
      </section>

      {/* Timelines */}
      <section className="pl-4 border-l-4 border-yellow-500">
        <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
          ⏳ समय-सीमा
        </h3>
        <ul className="list-disc ml-6 space-y-1 text-gray-700">
          <li>
            परियोजना को स्वीकृति की तिथि से <b>3 वर्षों</b> के भीतर पूर्ण करना
            अनिवार्य है।
          </li>
          <li>
            खर्च सब्सिडी (स्टाम्प ड्यूटी) वाणिज्यिक संचालन के <b>6 महीनों</b>{" "}
            के भीतर।
          </li>
          <li>
            ब्याज सब्सिडी वाणिज्यिक संचालन के 1 वर्ष पश्चात <b>90 दिनों</b> के
            भीतर।
          </li>
        </ul>
      </section>

      {/* Provisions */}
      <section className="pl-4 border-l-4 border-red-500">
        <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
          📌 योजना के प्रमुख प्रावधान
        </h3>
        <ul className="list-disc ml-6 space-y-1 text-gray-700">
          <li>उत्तराखंड के स्थायी निवासियों / उद्यमियों के लिए।</li>
          <li>निवेश सीमा: ₹1 करोड़ से ₹5 करोड़ तक।</li>
          <li>
            पात्र इकाइयाँ: एकल स्वामित्व, साझेदारी, LLP, प्राइवेट लिमिटेड आदि।
          </li>
          <li>भूमि स्वामित्व / लीज पर (न्यूनतम 10 वर्ष)।</li>
          <li>पात्र गतिविधियाँ: होटल, रिसॉर्ट, एडवेंचर पार्क आदि।</li>
        </ul>
      </section>

      {/* Subsidy */}
      <section className="pl-4 border-l-4 border-green-500">
        <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
          💰 वित्तीय सब्सिडी / प्रोत्साहन
        </h3>
        <ul className="list-disc ml-6 space-y-1 text-gray-700">
          <li>
            <b>स्टाम्प ड्यूटी:</b> 100% प्रतिपूर्ति (केवल नई इकाइयों हेतु)
          </li>
          <li>
            <b>खर्च सब्सिडी:</b>
            <ul className="list-disc ml-6 space-y-1">
              <li>₹1 करोड़ निवेश पर न्यूनतम ₹33 लाख</li>
              <li>श्रेणी A: 15% (अधिकतम ₹80 लाख)</li>
              <li>श्रेणी B: 25% (अधिकतम ₹1.2 करोड़)</li>
              <li>श्रेणी C: 30% (अधिकतम ₹1.5 करोड़)</li>
            </ul>
          </li>
          <li>
            <b>ब्याज सब्सिडी (3 वर्ष):</b>
            <ul className="list-disc ml-6 space-y-1">
              <li>श्रेणी A: 3% (अधिकतम ₹4 लाख/वर्ष)</li>
              <li>श्रेणी B: 3% (अधिकतम ₹5 लाख/वर्ष)</li>
              <li>श्रेणी C: 3% (अधिकतम ₹6 लाख/वर्ष)</li>
            </ul>
          </li>
        </ul>
      </section>

      {/* Regions */}
      <section className="pl-4 border-l-4 border-purple-500">
        <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
          📍 पात्र क्षेत्र
        </h3>
        <p className="text-gray-700 ml-6">
          <b>श्रेणी A:</b> हरिद्वार, नैनीताल, देहरादून (B क्षेत्र को छोड़कर),
          अल्मोड़ा (रानीखेत, अल्मोड़ा तहसील)।
          <br />
          <b>श्रेणी B:</b> देहरादून (कालसी, चकराता, त्यूणी), अल्मोड़ा (अन्य),
          बागेश्वर (गरुड़), पिथौरागढ़ (डीडीहाट, मुनाकोट), टिहरी (नई टिहरी)।
          <br />
          <b>श्रेणी C:</b> उत्तरकाशी, चम्पावत, पौड़ी, रुद्रप्रयाग, चमोली,
          बागेश्वर (अन्य), पिथौरागढ़ (अन्य), टिहरी (अन्य)।
        </p>
      </section>
    </div>
  ),
};

export default userGeneralInfoContent;
